export const ADD_NEW_NOTIF = "ADD_NEW_NOTIF";
export const REMOVE_NOTIF = "REMOVE_NOTIF";
